import "../styles/Slot.css";
function Slot({ time, slotsLeft, selected = false, onClick, disabled = false }) {

    const click = () => {
        if (disabled) {
            alert("This slot is not available");
            return;
        }
        onClick(time);
    }

    const classes = () => {
        let c = "slot-selection-card";
        if (selected) {
            c += " selected-card";
        }
        if (disabled) {
            c += " slot-disabled";
        }
        return c;
    }

    const slotLeftText = () => {
        if (disabled) {
            if (slotsLeft === 0) {
                return "Sold Out!";
            }
            return "Not available";
        }
        if (slotsLeft === 0) {
            return "No slots left";
        }
        if (slotsLeft === 1) {
            return "Only 1 slot left";
        }
        return `${slotsLeft} slots left`;
    }

    return (
        <div className={classes()} onClick={click}>
            <h2>{time}</h2>
            <p>
                {slotLeftText()}
            </p>
        </div>
    );
}

export default Slot;